<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 text-lg-start text-center">
          <h1 class="hero-title animate-fade-in" style="font-style: italic">{{ 'home.hero.title' | translate }}</h1>
          <p class="hero-subtitle animate-fade-in-delay">{{ 'home.hero.subtitle' | translate }}</p>
          <div class="hero-buttons animate-fade-in-delay-2">
            @if (isLoggedIn) {
              <a routerLink="/user-profile" class="btn-cta-primary">
                {{ 'home.hero.goToProfile' | translate }}
                <i class="fa fa-arrow-right ms-2"></i>
              </a>
              <a routerLink="/shows" class="btn-cta-primary">
                {{ 'home.hero.browseEvents' | translate }}
                <i class="fa fa-arrow-right ms-2"></i>
              </a>
            } @else {
              <a routerLink="/auth/register-user" class="btn-cta-primary">
                {{ 'home.hero.signUpFree' | translate }}
                <i class="fa fa-arrow-right ms-2"></i>
              </a>
              <a routerLink="/auth/register-user" class="btn-cta-primary">
                {{ 'home.hero.forBusiness' | translate }}
                <i class="fa fa-arrow-right ms-2"></i>
              </a>
            }
          </div>
          <div class="app-download-buttons animate-fade-in-delay-2">
            <a href="https://apps.apple.com/us/app/horseloop/id6757298760" target="_blank" rel="noopener noreferrer" class="app-store-btn">
              <i class="fab fa-apple"></i>
              <div class="app-store-text">
                <span>{{ 'home.hero.downloadOn' | translate }}</span>
                <strong>App Store</strong>
              </div>
            </a>
            <div class="app-store-btn app-store-btn-disabled">
              <i class="fab fa-google-play"></i>
              <div class="app-store-text">
                <span>{{ 'home.hero.getItOn' | translate }}</span>
                <strong>Google Play</strong>
              </div>
              <span class="app-coming-soon">{{ 'home.comingSoon' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Find Your Community Section -->
<section class="community-section">
  <div class="container">
    <h2 class="community-title">{{ 'home.community.title' | translate }}</h2>
    <p class="community-subtitle" [innerHTML]="'home.community.subtitle' | translate"></p>

    <div class="community-content-wrapper">
      <!-- Boxes View -->
      @if (!activeMapType) {
        <div class="community-grid">
          <!-- Stables Box -->
          <div class="community-box" (click)="showMap('stable')">
            <div class="community-box-image">
              <img src="assets/images/download4.jpeg" [alt]="'home.community.stables' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-warehouse"></i>
              </div>
              <h3>{{ 'home.community.stables' | translate }}</h3>
              <p>{{ 'home.community.stablesDesc' | translate }}</p>
            </div>
          </div>

          <!-- Riding Clubs Box -->
          <div class="community-box" (click)="showMap('riding_club')">
            <div class="community-box-image">
              <img src="assets/images/download.jpeg" [alt]="'home.community.ridingClubs' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-users"></i>
              </div>
              <h3>{{ 'home.community.ridingClubs' | translate }}</h3>
              <p>{{ 'home.community.ridingClubsDesc' | translate }}</p>
            </div>
          </div>

          <!-- Trainers Box -->
          <div class="community-box" (click)="showMap('trainer')">
            <div class="community-box-image">
              <img src="assets/images/download14.jpeg" [alt]="'home.community.trainers' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-chalkboard-teacher"></i>
              </div>
              <h3>{{ 'home.community.trainers' | translate }}</h3>
              <p>{{ 'home.community.trainersDesc' | translate }}</p>
            </div>
          </div>
        </div>

        <!-- Second Row - 4 Boxes with offset -->
        <div class="community-grid-offset">
          <!-- Horse Care Box -->
          <div class="community-box" (click)="showMap('horse_care')">
            <div class="community-box-image">
              <img src="assets/images/download13.jpeg" [alt]="'home.community.horseCare' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-heart"></i>
              </div>
              <h3>{{ 'home.community.horseCare' | translate }}</h3>
              <p>{{ 'home.community.horseCareDesc' | translate }}</p>
            </div>
          </div>

          <!-- Equipment & Tack Box -->
          <div class="community-box" (click)="showMap('equipment_tack')">
            <div class="community-box-image">
              <img src="assets/images/download15.jpeg" [alt]="'home.community.equipment' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-shopping-cart"></i>
              </div>
              <h3>{{ 'home.community.equipment' | translate }}</h3>
              <p>{{ 'home.community.equipmentDesc' | translate }}</p>
            </div>
          </div>

          <!-- Riding Schools Box - Coming Soon -->
          <div class="community-box community-box-coming-soon">
            <div class="community-box-image">
              <img src="assets/images/download2.jpeg" [alt]="'home.community.ridingAcademy' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-graduation-cap"></i>
              </div>
              <h3>{{ 'home.community.ridingAcademy' | translate }}</h3>
              <p>{{ 'home.community.ridingAcademyDesc' | translate }}</p>
            </div>
            <div class="coming-soon-badge">{{ 'home.comingSoon' | translate }}</div>
          </div>

          <!-- Breeding Box - Coming Soon -->
          <div class="community-box community-box-coming-soon">
            <div class="community-box-image">
              <img src="assets/images/download12.jpeg" [alt]="'home.community.breeding' | translate" />
              <div class="community-box-overlay"></div>
            </div>
            <div class="community-box-content">
              <div class="community-box-icon">
                <i class="fa fa-star"></i>
              </div>
              <h3>{{ 'home.community.breeding' | translate }}</h3>
              <p>{{ 'home.community.breedingDesc' | translate }}</p>
            </div>
            <div class="coming-soon-badge">{{ 'home.comingSoon' | translate }}</div>
          </div>
        </div>
      }

      <!-- Map View -->
      @if (activeMapType) {
        <div class="community-map-view">
          <div class="map-tabs">
            <button
              class="map-tab"
              [class.active]="activeMapType === 'stable'"
              (click)="showMap('stable')"
            >
              <i class="fa fa-warehouse"></i>
              {{ 'home.community.stables' | translate }}
            </button>
            <button
              class="map-tab"
              [class.active]="activeMapType === 'riding_club'"
              (click)="showMap('riding_club')"
            >
              <i class="fa fa-users"></i>
              {{ 'home.community.ridingClubs' | translate }}
            </button>
            <button
              class="map-tab"
              [class.active]="activeMapType === 'trainer'"
              (click)="showMap('trainer')"
            >
              <i class="fa fa-chalkboard-teacher"></i>
              {{ 'home.community.trainers' | translate }}
            </button>
            <button
              class="map-tab"
              [class.active]="activeMapType === 'horse_care'"
              (click)="showMap('horse_care')"
            >
              <i class="fa fa-heart"></i>
              {{ 'home.community.horseCare' | translate }}
            </button>
            <button
              class="map-tab"
              [class.active]="activeMapType === 'equipment_tack'"
              (click)="showMap('equipment_tack')"
            >
              <i class="fa fa-shopping-cart"></i>
              {{ 'home.community.equipment' | translate }}
            </button>
            <button class="map-tab-back" (click)="hideMap()">
              <i class="fa fa-arrow-left"></i>
              {{ 'common.back' | translate }}
            </button>
          </div>
          <app-location-map
            [markers]="currentMarkers"
            [config]="mapConfig"
            [loading]="geocodingInProgress"
            (markerClick)="onMarkerClick($event)"
            (infoWindowAction)="onMarkerAction($event)"
          ></app-location-map>
        </div>
      }
    </div>
  </div>
</section>

<!-- Solution Section -->
<section class="solution-section">
  <div class="container" style="max-width: 1200px">
    <div class="row align-items-center g-5">
      <div class="col-lg-6 order-lg-2">
        <span class="section-badge section-badge-light">{{ 'home.solution.badge' | translate }}</span>
        <h2 class="section-title text-white">{{ 'home.solution.title' | translate }}</h2>
        <p class="section-text text-white-75">{{ 'home.solution.description' | translate }}</p>
        <div class="solution-highlights">
          <div class="solution-highlight">
            <div class="highlight-icon">
              <i class="fa fa-bolt"></i>
            </div>
            <div class="highlight-content">
              <h4>{{ 'home.solution.highlight1Title' | translate }}</h4>
              <p>{{ 'home.solution.highlight1Desc' | translate }}</p>
            </div>
          </div>
          <div class="solution-highlight">
            <div class="highlight-icon">
              <i class="fa fa-shield-alt"></i>
            </div>
            <div class="highlight-content">
              <h4>{{ 'home.solution.highlight2Title' | translate }}</h4>
              <p>{{ 'home.solution.highlight2Desc' | translate }}</p>
            </div>
          </div>
          <div class="solution-highlight">
            <div class="highlight-icon">
              <i class="fa fa-heart"></i>
            </div>
            <div class="highlight-content">
              <h4>{{ 'home.solution.highlight3Title' | translate }}</h4>
              <p>{{ 'home.solution.highlight3Desc' | translate }}</p>
            </div>
          </div>
        </div>
        @if (isLoggedIn) {
          <a routerLink="/user-profile" class="btn-learn-more">
            {{ 'home.hero.goToProfile' | translate }}
            <i class="fa fa-arrow-right ms-2"></i>
          </a>
        } @else {
          <a routerLink="/auth/register-user" class="btn-learn-more">
            {{ 'home.solution.joinNow' | translate }}
            <i class="fa fa-arrow-right ms-2"></i>
          </a>
        }
      </div>
      <div class="col-lg-6 order-lg-1">
        <div class="solution-image-wrapper">
          <img src="assets/images/img_2.png" alt="HorseLoop Solution" />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Why Join Section - Two Audiences -->
<!--<section class="why-join-section">-->
<!--  <div class="container" style="max-width: 1200px">-->
<!--    <div class="text-center mb-5">-->
<!--      <span class="section-badge">{{ 'home.whyJoin.badge' | translate }}</span>-->
<!--      <h2 class="section-title">{{ 'home.whyJoin.title' | translate }}</h2>-->
<!--      <p class="section-subtitle">{{ 'home.whyJoin.subtitle' | translate }}</p>-->
<!--    </div>-->

<!--    <div class="row g-5">-->
<!--      &lt;!&ndash; For Participants &ndash;&gt;-->
<!--      <div class="col-lg-6">-->
<!--        <div class="audience-card audience-card-participant">-->
<!--          <div class="audience-icon">-->
<!--            <i class="fa fa-user-check"></i>-->
<!--          </div>-->
<!--          <h3 class="audience-title">{{ 'home.whyJoin.participantTitle' | translate }}</h3>-->
<!--          <p class="audience-desc">{{ 'home.whyJoin.participantDesc' | translate }}</p>-->
<!--          <ul class="audience-benefits">-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.participantBenefit1' | translate }}</span>-->
<!--            </li>-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.participantBenefit2' | translate }}</span>-->
<!--            </li>-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.participantBenefit3' | translate }}</span>-->
<!--            </li>-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.participantBenefit4' | translate }}</span>-->
<!--            </li>-->
<!--          </ul>-->
<!--          <a routerLink="/auth/register-user" class="btn-audience btn-audience-participant">-->
<!--            {{ 'home.whyJoin.participantCta' | translate }}-->
<!--            <i class="fa fa-arrow-right ms-2"></i>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; For Organizations &ndash;&gt;-->
<!--      <div class="col-lg-6">-->
<!--        <div class="audience-card audience-card-organization">-->
<!--          <div class="audience-icon">-->
<!--            <i class="fa fa-building"></i>-->
<!--          </div>-->
<!--          <h3 class="audience-title">{{ 'home.whyJoin.organizationTitle' | translate }}</h3>-->
<!--          <p class="audience-desc">{{ 'home.whyJoin.organizationDesc' | translate }}</p>-->
<!--          <ul class="audience-benefits">-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.organizationBenefit1' | translate }}</span>-->
<!--            </li>-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.organizationBenefit2' | translate }}</span>-->
<!--            </li>-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.organizationBenefit3' | translate }}</span>-->
<!--            </li>-->
<!--            <li>-->
<!--              <i class="fa fa-check-circle"></i>-->
<!--              <span>{{ 'home.whyJoin.organizationBenefit4' | translate }}</span>-->
<!--            </li>-->
<!--          </ul>-->
<!--          <a routerLink="/auth/register-user" class="btn-audience btn-audience-organization">-->
<!--            {{ 'home.whyJoin.organizationCta' | translate }}-->
<!--            <i class="fa fa-arrow-right ms-2"></i>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->

<!-- How It Works Section -->
<!--<section class="how-it-works-section">-->
<!--  <div class="container" style="max-width: 1200px">-->
<!--    <div class="text-center mb-5">-->
<!--      <span class="section-badge">{{ 'home.howItWorks.badge' | translate }}</span>-->
<!--      <h2 class="section-title">{{ 'home.howItWorks.title' | translate }}</h2>-->
<!--      <p class="section-subtitle">{{ 'home.howItWorks.subtitle' | translate }}</p>-->
<!--    </div>-->

<!--    <div class="steps-timeline">-->
<!--      <div class="step-item">-->
<!--        <div class="step-icon-wrapper">-->
<!--          <div class="step-icon">-->
<!--            <i class="fa fa-user-plus"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="step-content">-->
<!--          <h3 class="step-title">{{ 'home.howItWorks.step1Title' | translate }}</h3>-->
<!--          <p class="step-text">{{ 'home.howItWorks.step1Desc' | translate }}</p>-->
<!--        </div>-->
<!--        <div class="step-arrow">-->
<!--          <i class="fa fa-chevron-right"></i>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="step-item">-->
<!--        <div class="step-icon-wrapper">-->
<!--          <div class="step-icon">-->
<!--            <i class="fa fa-search"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="step-content">-->
<!--          <h3 class="step-title">{{ 'home.howItWorks.step2Title' | translate }}</h3>-->
<!--          <p class="step-text">{{ 'home.howItWorks.step2Desc' | translate }}</p>-->
<!--        </div>-->
<!--        <div class="step-arrow">-->
<!--          <i class="fa fa-chevron-right"></i>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="step-item">-->
<!--        <div class="step-icon-wrapper">-->
<!--          <div class="step-icon">-->
<!--            <i class="fa fa-calendar-check"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="step-content">-->
<!--          <h3 class="step-title">{{ 'home.howItWorks.step3Title' | translate }}</h3>-->
<!--          <p class="step-text">{{ 'home.howItWorks.step3Desc' | translate }}</p>-->
<!--        </div>-->
<!--        <div class="step-arrow">-->
<!--          <i class="fa fa-chevron-right"></i>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="step-item step-item-last">-->
<!--        <div class="step-icon-wrapper step-icon-success">-->
<!--          <div class="step-icon">-->
<!--            <i class="fa fa-trophy"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="step-content">-->
<!--          <h3 class="step-title">{{ 'home.howItWorks.step4Title' | translate }}</h3>-->
<!--          <p class="step-text">{{ 'home.howItWorks.step4Desc' | translate }}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->

<!-- Stats Section -->
<!--<section class="stats-section">-->
<!--  <div class="container">-->
<!--    <div class="stats-grid">-->
<!--      <div class="stat-item">-->
<!--        <div class="stat-number">{{ 'home.stats.freeLabel' | translate }}</div>-->
<!--        <div class="stat-label">{{ 'home.stats.forParticipants' | translate }}</div>-->
<!--      </div>-->
<!--      <div class="stat-item">-->
<!--        <div class="stat-number">100+</div>-->
<!--        <div class="stat-label">{{ 'home.stats.organizations' | translate }}</div>-->
<!--      </div>-->
<!--      <div class="stat-item">-->
<!--        <div class="stat-number">1000+</div>-->
<!--        <div class="stat-label">{{ 'home.stats.eventsYearly' | translate }}</div>-->
<!--      </div>-->
<!--      <div class="stat-item">-->
<!--        <div class="stat-number">20+</div>-->
<!--        <div class="stat-label">{{ 'home.stats.disciplines' | translate }}</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->

<!-- CTA Section -->
<section class="cta-section">
  <div class="container text-center">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <h2 class="cta-title">{{ 'home.cta.title' | translate }}</h2>
        <p class="cta-text">{{ 'home.cta.description' | translate }}</p>
        <div class="cta-buttons">
          @if (isLoggedIn) {
            <a routerLink="/user-profile" class="btn-cta-light">
              <i class="fa fa-user me-2"></i>
              {{ 'home.hero.goToProfile' | translate }}
            </a>
            <a routerLink="/shows" class="btn-cta-outline">
              <i class="fa fa-calendar me-2"></i>
              {{ 'home.hero.browseEvents' | translate }}
            </a>
          } @else {
            <a routerLink="/auth/register-user" class="btn-cta-light">
              <i class="fa fa-user me-2"></i>
              {{ 'home.cta.participantButton' | translate }}
            </a>
            <a routerLink="/auth/register-user" class="btn-cta-outline">
              <i class="fa fa-building me-2"></i>
              {{ 'home.cta.organizationButton' | translate }}
            </a>
          }
        </div>
        <div class="cta-browse-link">
          <a routerLink="/shows" class="browse-events-link">
            {{ 'home.cta.browseEvents' | translate }}
            <i class="fa fa-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
